import { Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";          // 👈 เพิ่มบรรทัดนี้
import "../../../shared/styles/BrowseCategory.css";

const items = [
  { id: 1, label: "Productivity", query: "AI for Productivity" },
  { id: 2, label: "Creatives", query: "AI for Creatives" },
  { id: 3, label: "AI Automation", query: "AI Automation" },
  { id: 4, label: "Developers", query: "AI for Developers" },
];

export default function BrowseCategory() {
  return (
    <Row xs={2} lg={4} className="g-3">
      {items.map((it) => (
        <Col key={it.id}>
          <Card
            as={Link}
            to={`/search?q=${encodeURIComponent(it.query)}`} // 👈 ส่งค่า title ไปหน้า search
            className="h-100 shadow-sm border-0 btn-gradient text-white text-center browse-card"
          >
            <Card.Body className="py-4 fw-bold">
              {it.label}
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}